import { Container } from "@mui/material";
import SectionTitle from "../../components/SectionTitle";
import Slider from "react-slick";
import TeamMember from "../../components/TeamMember";
import { TEAM } from "../../constants";

const TeamSection = () => {
  var settings = {
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };
  return (
    <section id="team">
      <Container>
        <SectionTitle title="TEAM"></SectionTitle>
        <div
          style={{
            paddingLeft: "32px",
            paddingRight: "32px",
            marginTop: "20px",
          }}
        >
          <Slider {...settings}>
            {TEAM.map((member) => (
              <TeamMember
                key={member.name}
                image={member.image}
                name={member.name}
                role={member.role}
                social={member.social}
              ></TeamMember>
            ))}
          </Slider>
        </div>
      </Container>
    </section>
  );
};

export default TeamSection;
